import GetApp from '@mui/icons-material/GetApp';
import { Button, CircularProgress } from '@mui/material';
import { getLabel } from '@shared/utils';
import { exportToCSV } from '@shared/utils/fileExport';
import { useState } from 'react';

type ExportTableDataProps = {
  fileName: string;
  fileExtension?: string;
  getData: () => Promise<unknown[]> | unknown[];
  disabled?: boolean;
};

const ExportTableData = ({ fileName, fileExtension = '.csv', getData, disabled = false }: ExportTableDataProps) => {
  const [loading, setLoading] = useState(false);

  const exportData = async () => {
    setLoading(true);
    const data = await getData();
    setLoading(false);
    exportToCSV(data as Record<string, unknown>[], fileName, fileExtension);
  };

  return (
    <Button onClick={exportData} variant="contained" color="primary" startIcon={<GetApp />} disabled={disabled}>
      {getLabel('exportData')}
      {loading && <CircularProgress size={20} color="secondary" />}
    </Button>
  );
};

export default ExportTableData;
